var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34691 0.754272C5.54409 0.756399 3.81571 1.47351 2.54091 2.7483C1.26612 4.0231 0.549009 5.75148 0.546882 7.5543C0.544723 9.02758 1.02596 10.4609 1.91678 11.6343C1.91678 11.6343 2.10223 11.8785 2.13253 11.9137L7.34691 18.0634L12.5638 11.9107C12.591 11.8779 12.777 11.6343 12.777 11.6343L12.7777 11.6325C13.668 10.4595 14.1491 9.0269 14.1469 7.5543C14.1448 5.75148 13.4277 4.0231 12.1529 2.7483C10.8781 1.47351 9.14974 0.756399 7.34691 0.754272ZM7.34691 10.027C6.85785 10.027 6.37977 9.88202 5.97313 9.61031C5.56649 9.3386 5.24956 8.95241 5.0624 8.50058C4.87524 8.04875 4.82628 7.55156 4.92169 7.0719C5.0171 6.59223 5.2526 6.15163 5.59842 5.80581C5.94424 5.45999 6.38484 5.22449 6.86451 5.12908C7.34417 5.03367 7.84135 5.08263 8.29319 5.26979C8.74502 5.45695 9.13121 5.77388 9.40292 6.18052C9.67463 6.58716 9.81965 7.06524 9.81965 7.5543C9.81883 8.20986 9.55805 8.83834 9.0945 9.30189C8.63095 9.76544 8.00247 10.0262 7.34691 10.027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.636dc7d34ab9231ef6a3d53b5d19d647.svg";
export { ForwardRef as ReactComponent };